export default {
  control: (styles) => ({
    ...styles,
    height: "32px",
    minHeight: "32px",
    width: "220px",
    border: "none",
  }),
  valueContainer: (styles) => ({
    ...styles,
    flexWrap: "nowrap",
    overflow: "auto hidden",
    height: "100",
  }),
  multiValue: (styles) => ({
    ...styles,
    minWidth: "auto",
    height: "100",
    paddingBotton: "10px",
  }),
  option: (baseStyles, { data }) => ({
    color: data.active === false ? "grey" : baseStyles.color,
    height: "100",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "100%",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    height: "100%",
    display: "flex",
    alignItems: "center",
  }),
  clearIndicator: (base) => ({
    ...base,
    height: "100%",
    display: "flex",
    alignItems: "center",
  }),
};
